// 'review' namespace — keys are prefixed 'review.'. Russian is the primary UI language.
const ru: Record<string, string> = {
  'review.pen.title': 'Проверка на рукописи',
  'review.pen.toggle': 'Красная ручка',
  'review.pen.hint': 'Нажмите на красную пометку, чтобы увидеть объяснение.',
  'review.pen.summary': 'На рукописи отмечено замечаний: {placed} из {total}.',
  'review.pen.unplaced': 'Остальные ({n}) не удалось надёжно привязать к почерку — они в списке ниже.',
  'review.pen.lowCoverage': 'Распознанный текст плохо совпадает с расположением слов на странице: пометки показаны только там, где мы уверены.',
  'review.pen.canvas': 'Рукопись с пометками, страница {n}',
  // Pipeline
  'review.steps.label': 'Этапы проверки',
  'review.steps.transcribe': 'Распознавание',
  'review.steps.confirm': 'Проверка текста',
  'review.steps.evaluate': 'Оценка',
  'review.steps.done': 'Разбор',

  // Jobs
  'review.job.transcribing': 'Распознаём почерк…',
  'review.job.transcribingText':
    'Переводим рукопись в текст. Затем вы сверите его с оригиналом — без вашего подтверждения ничего не оценивается.',
  'review.job.evaluating': 'Оцениваем текст…',
  'review.job.evaluatingText': 'Сравниваем подтверждённый текст с образцом.',
  'review.job.evaluatingTextAi':
    'Проверяем грамматику, орфографию и выполнение задания по учебной шкале A2. Обычно это занимает до минуты.',
  'review.job.safe':
    'Рукопись уже сохранена на сервере — ничего не потеряется. Можно уйти со страницы: результат появится в истории.',
  'review.job.status.queued': 'В очереди',
  'review.job.status.running': 'Выполняется',
  'review.job.status.succeeded': 'Готово',
  'review.job.status.failed': 'Ошибка',
  'review.job.status.cancelled': 'Отменено',
  'review.job.elapsed': 'Прошло {s}',
  'review.job.retries': 'Повторных попыток: {n}',
  'review.job.cancel': 'Отменить',
  'review.job.cancelled': 'Задача отменена. Рукопись и прежние версии сохранены.',

  // Failures
  'review.fail.transcribeTitle': 'Не удалось распознать почерк',
  'review.fail.transcribeText':
    'Рукопись не пострадала. Попробуйте распознать ещё раз или введите текст вручную — точно так, как написали.',
  'review.fail.evaluateTitle': 'Не удалось оценить текст',
  'review.fail.evaluateText':
    'Подтверждённый текст и рукопись сохранены. Повторите оценку — прежние версии не пропадут.',
  'review.fail.retryOcr': 'Распознать снова',
  'review.fail.typeManually': 'Ввести текст вручную',
  'review.fail.retryEvaluate': 'Оценить снова',

  // Provenance
  'review.prov.ocr': 'Распознано: {provider}',
  'review.prov.mock': 'Тестовый режим (mock) — не настоящее распознавание',
  'review.prov.manual': 'Введено вручную',
  'review.prov.none': 'Почерк не найден',

  // Transcript confirmation
  'review.confirm.rule':
    'Исправьте распознавание так, чтобы текст точно совпадал с тем, что вы написали — не исправляйте свои ошибки!',
  'review.confirm.ruleText':
    'Сохраните все тоносы, буквы и знаки ровно как на странице — даже если знаете, что написали неверно. Зачёркнутые слова не переносите. Ошибки — тоносы, буквы, грамматику — разберём на следующем шаге и покажем красной ручкой прямо на рукописи.',
  'review.confirm.noReference':
    'Образец здесь специально не показан, чтобы не подталкивать к исправлению ошибок. Сравнение с ним — сразу после подтверждения.',
  'review.confirm.blank': 'На страницах не найден почерк. Если вы всё же писали, введите текст вручную.',
  'review.confirm.rawTitle': 'Как распознано',
  'review.confirm.rawHint':
    'Исходный результат распознавания. Сомнительные места выделены — нажмите, чтобы найти их в редакторе.',
  'review.confirm.uncertainCount': 'Сомнительных мест: {n}',
  'review.confirm.uncertainTitle': 'Проверьте внимательно',
  'review.confirm.notes': 'Заметки распознавания',
  'review.confirm.label': 'Текст для проверки',
  'review.confirm.editLabel': 'Исправленный текст (новая версия)',
  'review.confirm.placeholder': 'Γράψτε εδώ το κείμενο ακριβώς όπως το γράψατε…',
  'review.confirm.keyboardHint':
    'Набирайте с греческой раскладкой. Автоисправление отключено, чтобы клавиатура не «чинила» ошибки.',
  'review.confirm.mixedScript': 'Похоже, в словах смешаны греческие и латинские буквы:',
  'review.confirm.reset': 'Вернуть распознанный текст',
  'review.confirm.submit': 'Подтвердить текст',
  'review.confirm.submitEdit': 'Сохранить и оценить заново',
  'review.confirm.afterCopy':
    'После подтверждения текст сразу сравнится с образцом. Распознанный вариант сохранится отдельно.',
  'review.confirm.afterFree':
    'После подтверждения начнётся оценка. Распознанный вариант сохранится отдельно, его можно будет посмотреть.',
  'review.confirm.emptyTitle': 'Подтвердить пустой текст?',
  'review.confirm.emptyText':
    'Работа будет оценена как пустая. Если на странице есть текст, лучше ввести его.',
  'review.confirm.doneCopy': 'Текст подтверждён — сравнение готово',
  'review.confirm.doneFree': 'Текст подтверждён — начинаем оценку',
  'review.confirm.stale': 'Текст изменился на другом устройстве. Загружаем свежую версию.',

  // Handwriting
  'review.hw.title': 'Рукопись',
  'review.hw.original': 'Оригинал рукописи',
  'review.hw.canvas': 'Рукопись, страница {n}',
  'review.hw.pages': 'Страницы рукописи',
  'review.hw.pageOf': 'Стр. {n} из {total}',
  'review.hw.noPages': 'В этой работе нет страниц.',

  // Common feedback
  'review.emptyText': 'Текст пуст',
  'review.show': 'Показать',
  'review.hide': 'Скрыть',
  'review.minor': 'мелочь',
  'review.likely': 'вероятно',
  'review.uncertain': 'не уверено',
  'review.version': 'Версия {v}',
  'review.versionPick': 'Оценка',
  'review.latest': 'последняя',
  'review.olderVersion': 'Вы смотрите версию {v}. Последняя — версия {latest}.',
  'review.toLatest': 'К последней',
  'review.meta.deterministic': 'Точное сравнение с образцом, без ИИ',
  'review.meta.mock': 'Тестовый ИИ (mock) — оценка не настоящая',
  'review.meta.basedOn': 'по тексту v{v}',
  'review.evalFailedVersion': 'Эта версия оценки завершилась ошибкой: {msg}',
  'review.noResult': 'Для этой версии нет результата.',
  'review.issues.title': 'Ошибки',
  'review.word.one': 'слово',
  'review.word.few': 'слова',
  'review.word.many': 'слов',

  // Copy / recall
  'review.metric.char': 'Точность букв',
  'review.metric.word': 'Слова без ошибок',
  'review.metric.accent': 'Тоносы',
  'review.metric.punct': 'Пунктуация',
  'review.metric.completion': 'Написано из образца',
  'review.metric.charDetail': 'ошибок: {e} на {n} знаков',
  'review.metric.of': '{a} из {n}',
  'review.metric.accentDetail': '{a} из {n} · лишних {x}',
  'review.copy.notOfficial': 'Это учебная статистика точности копирования, а не экзаменационная оценка.',
  'review.copy.blank':
    'В подтверждённом тексте нет слов — сравнивать не с чем. Если вы писали, проверьте распознавание.',
  'review.copy.partial':
    'Текст написан не до конца (около {p} образца). Пропущенная концовка учтена отдельно, остальное оценено как есть.',
  'review.copy.counts': 'Ошибки по типам',
  'review.copy.diffTitle': 'Сравнение с образцом',
  'review.copy.diffHint': 'Нажмите на выделение, чтобы найти пояснение',
  'review.copy.reference': 'Образец',
  'review.copy.yours': 'Ваш текст (подтверждённый)',
  'review.copy.notInReference': 'нет в образце',
  'review.copy.missing': 'пропущено',
  'review.copy.writtenAs': 'написано как',
  'review.copy.perfect': 'Ни одного расхождения с образцом. Отличная работа!',
  'review.copy.recallSection': 'Что не удалось вспомнить',
  'review.copy.formSection': 'Орфография, тоносы и знаки',
  'review.group.recall': 'Слова: пропуски и замены',
  'review.group.recallMode': 'Пропуски и замены слов',
  'review.group.orthography': 'Орфография',
  'review.group.accent': 'Тонос',
  'review.group.punctuation': 'Пунктуация',
  'review.group.layout': 'Пробелы и абзацы',
  'review.drill.start': 'Отработать',
  'review.drill.title': 'Повтор фрагмента',

  // Free / exam
  'review.free.score': 'Учебная оценка',
  'review.free.words': 'Слов в тексте: {n}',
  'review.free.summary': 'Итог',
  'review.free.strengths': 'Что получилось',
  'review.free.rubric': 'Критерии',
  'review.free.rubricNote': 'учебная шкала, не официальная',
  'review.free.coverage': 'Выполнение задания',
  'review.free.point': 'Пункт задания',
  'review.free.covered': 'Раскрыт',
  'review.free.evidence': 'Где в тексте',
  'review.cov.yes': 'да',
  'review.cov.partly': 'частично',
  'review.cov.no': 'нет',
  'review.free.yourText': 'Ваш текст с пометками',
  'review.free.errors': 'Ошибки',
  'review.free.noErrors': 'Явных ошибок не найдено.',
  'review.free.acceptable': 'Допустимо',
  'review.free.optional': 'Можно улучшить',
  'review.free.unlocated': 'Не удалось привязать к тексту',
  'review.free.unlocatedNote':
    'Эти замечания не удалось точно сопоставить с местом в тексте, поэтому они не отмечены выше.',
  'review.free.suggested': 'лучше так',
  'review.free.relocated': 'Место в тексте уточнено автоматически.',
  'review.free.corrected': 'Минимальная правка',
  'review.free.correctedNote':
    'Исправленный вариант на уровне A2 — отдельно от вашего оригинала, который не меняется.',
  'review.free.limitations': 'Ограничения оценки',
  'review.free.noText': 'Подтверждённый текст для этой версии недоступен, поэтому пометки не показаны.',
  'review.kind.incorrect': 'Ошибка',
  'review.kind.acceptable': 'Допустимо',
  'review.kind.optional': 'Можно улучшить',
  'review.family.accent': 'Тонос',
  'review.family.orthography': 'Орфография',
  'review.family.grammar': 'Грамматика',
  'review.family.punctuation': 'Пунктуация',
  'review.family.style': 'Лексика и стиль',

  // Annotation layer
  'review.annot.title': 'Пометки в тексте',
  'review.annot.toggle': 'Пометки',
  'review.annot.note': 'Пометки относятся к подтверждённому тексту, а не к месту на рукописи. Отмечено: {n}.',

  // Versions & actions
  'review.versions.title': 'Версии текста',
  'review.versions.ocr': 'Распознано · v{v}',
  'review.versions.confirmed': 'Подтверждено · v{v}',
  'review.versions.rawBadge': 'Исходное распознавание',
  'review.versions.confirmedBadge': 'Подтверждено вами',
  'review.versions.graded': 'Оценена эта версия',
  'review.editText': 'Исправить текст',
  'review.reEvaluate': 'Оценить заново',
  'review.reEvaluateTitle': 'Оценить заново?',
  'review.reEvaluateText': 'Будет создана новая версия оценки. Текущая сохранится, и её можно будет открыть.',
  'review.reEvaluated': 'Сравнение пересчитано',
  'review.aiOff': 'ИИ-оценка сейчас отключена',
  'review.again': 'Ещё попытка',
  'review.teacherWaiting':
    'Ученик ещё не подтвердил распознанный текст. Разбор появится после подтверждения.',
  'review.export.pdf': 'Скачать PDF',
  'review.export.json': 'Скачать JSON',
  'review.delete': 'Удалить попытку',
  'review.deleteTitle': 'Удалить эту попытку?',
  'review.deleteText': 'Попытка исчезнет из истории и статистики, а доступ преподавателей будет закрыт.',
  'review.deleted': 'Попытка удалена',

  // Teacher
  'review.teacher.title': 'Отзывы преподавателя',
  'review.teacher.badge': 'преподаватель',
  'review.teacher.note': 'Преподаватель видит работу только для чтения: оригинал и ваши версии не меняются.',

  // Sharing
  'review.share.open': 'Поделиться',
  'review.share.title': 'Показать преподавателю',
  'review.share.text': 'Преподаватель увидит рукопись, подтверждённый текст и разбор — только для чтения.',
  'review.share.email': 'Email преподавателя',
  'review.share.allowComments': 'Разрешить комментарии и оценки',
  'review.share.allowCommentsHint': 'Преподаватель сможет оставить отзыв к этой попытке',
  'review.share.privacy':
    'Делиться можно только с приглашёнными преподавателями. Доступ можно закрыть в любой момент.',
  'review.share.submit': 'Поделиться',
  'review.share.done': 'Доступ открыт для {email}',
  'review.share.panel': 'Доступ преподавателей',
  'review.share.none': 'Пока никто не видит эту попытку.',
  'review.share.canComment': 'может комментировать',
  'review.share.viewOnly': 'только просмотр',
  'review.share.revoke': 'Закрыть доступ',
  'review.share.revokeTitle': 'Закрыть доступ?',
  'review.share.revokeText':
    '{email} сразу перестанет видеть эту попытку. Уже оставленные отзывы сохранятся у вас.',
  'review.share.revoked': 'Доступ закрыт',
};

const en: Record<string, string> = {
  'review.pen.title': 'Marked on your handwriting',
  'review.pen.toggle': 'Red pen',
  'review.pen.hint': 'Tap a red mark to see the explanation.',
  'review.pen.summary': 'Marked on the handwriting: {placed} of {total} remarks.',
  'review.pen.unplaced': 'The rest ({n}) could not be placed reliably on the handwriting — see the list below.',
  'review.pen.lowCoverage': 'The text does not line up well with the words on the page: marks are shown only where we are sure.',
  'review.pen.canvas': 'Handwriting with corrections, page {n}',
  'review.steps.label': 'Review steps',
  'review.steps.transcribe': 'Recognition',
  'review.steps.confirm': 'Check text',
  'review.steps.evaluate': 'Evaluation',
  'review.steps.done': 'Feedback',

  'review.job.transcribing': 'Reading your handwriting…',
  'review.job.transcribingText':
    'Turning the handwriting into text. You will then check it against the original — nothing is graded before you confirm.',
  'review.job.evaluating': 'Evaluating…',
  'review.job.evaluatingText': 'Comparing the confirmed text with the reference.',
  'review.job.evaluatingTextAi':
    'Checking grammar, spelling and task coverage on the A2 practice rubric. This usually takes under a minute.',
  'review.job.safe':
    'Your handwriting is already saved on the server — nothing will be lost. You can leave this page; the result will appear in History.',
  'review.job.status.queued': 'Queued',
  'review.job.status.running': 'Running',
  'review.job.status.succeeded': 'Done',
  'review.job.status.failed': 'Failed',
  'review.job.status.cancelled': 'Cancelled',
  'review.job.elapsed': 'Elapsed {s}',
  'review.job.retries': 'Retries: {n}',
  'review.job.cancel': 'Cancel',
  'review.job.cancelled': 'Job cancelled. Your handwriting and earlier versions are kept.',

  'review.fail.transcribeTitle': 'Could not read the handwriting',
  'review.fail.transcribeText':
    'Your handwriting is safe. Try recognition again, or type the text yourself — exactly as you wrote it.',
  'review.fail.evaluateTitle': 'Could not evaluate the text',
  'review.fail.evaluateText':
    'The confirmed text and handwriting are saved. Retry the evaluation — earlier versions are kept.',
  'review.fail.retryOcr': 'Recognise again',
  'review.fail.typeManually': 'Type the text',
  'review.fail.retryEvaluate': 'Evaluate again',

  'review.prov.ocr': 'Recognised by {provider}',
  'review.prov.mock': 'Test mode (mock) — not real recognition',
  'review.prov.manual': 'Typed manually',
  'review.prov.none': 'No handwriting found',

  'review.confirm.rule':
    'Correct the recognition so the text matches exactly what you wrote — do not fix your own mistakes!',
  'review.confirm.ruleText':
    'Keep every tonos, letter and mark exactly as on the page — even if you know it is wrong. Leave out crossed-out words. Mistakes (accents, letters, grammar) are marked in the next step, in red pen on your handwriting.',
  'review.confirm.noReference':
    'The reference is hidden here on purpose so it does not nudge you into fixing mistakes. The comparison comes right after you confirm.',
  'review.confirm.blank': 'No handwriting was found on the pages. If you did write something, type it in.',
  'review.confirm.rawTitle': 'As recognised',
  'review.confirm.rawHint':
    'The original recognition result. Uncertain places are highlighted — tap one to find it in the editor.',
  'review.confirm.uncertainCount': '{n} uncertain',
  'review.confirm.uncertainTitle': 'Check carefully',
  'review.confirm.notes': 'Recognition notes',
  'review.confirm.label': 'Text to check',
  'review.confirm.editLabel': 'Corrected text (new version)',
  'review.confirm.placeholder': 'Γράψτε εδώ το κείμενο ακριβώς όπως το γράψατε…',
  'review.confirm.keyboardHint':
    'Type with a Greek keyboard. Autocorrect is off so the keyboard does not “fix” mistakes.',
  'review.confirm.mixedScript': 'Some words seem to mix Greek and Latin letters:',
  'review.confirm.reset': 'Restore recognised text',
  'review.confirm.submit': 'Confirm text',
  'review.confirm.submitEdit': 'Save and re-grade',
  'review.confirm.afterCopy':
    'After you confirm, the text is compared with the reference right away. The recognised version is kept separately.',
  'review.confirm.afterFree':
    'After you confirm, evaluation starts. The recognised version is kept separately and stays viewable.',
  'review.confirm.emptyTitle': 'Confirm an empty text?',
  'review.confirm.emptyText': 'The attempt will be graded as blank. If the page has text, better type it in.',
  'review.confirm.doneCopy': 'Text confirmed — comparison ready',
  'review.confirm.doneFree': 'Text confirmed — evaluation started',
  'review.confirm.stale': 'The text changed on another device. Loading the latest version.',

  'review.hw.title': 'Handwriting',
  'review.hw.original': 'Original handwriting',
  'review.hw.canvas': 'Handwriting, page {n}',
  'review.hw.pages': 'Handwriting pages',
  'review.hw.pageOf': 'Page {n} of {total}',
  'review.hw.noPages': 'This attempt has no pages.',

  'review.emptyText': 'The text is empty',
  'review.show': 'Show',
  'review.hide': 'Hide',
  'review.minor': 'minor',
  'review.likely': 'likely',
  'review.uncertain': 'uncertain',
  'review.version': 'Version {v}',
  'review.versionPick': 'Evaluation',
  'review.latest': 'latest',
  'review.olderVersion': 'You are viewing version {v}. The latest is version {latest}.',
  'review.toLatest': 'Go to latest',
  'review.meta.deterministic': 'Exact comparison with the reference, no AI',
  'review.meta.mock': 'Test AI (mock) — not a real evaluation',
  'review.meta.basedOn': 'on text v{v}',
  'review.evalFailedVersion': 'This evaluation version failed: {msg}',
  'review.noResult': 'No result for this version.',
  'review.issues.title': 'Mistakes',
  'review.word.one': 'word',
  'review.word.few': 'words',
  'review.word.many': 'words',

  'review.metric.char': 'Letter accuracy',
  'review.metric.word': 'Words without errors',
  'review.metric.accent': 'Tonos',
  'review.metric.punct': 'Punctuation',
  'review.metric.completion': 'Reference covered',
  'review.metric.charDetail': '{e} errors in {n} characters',
  'review.metric.of': '{a} of {n}',
  'review.metric.accentDetail': '{a} of {n} · {x} extra',
  'review.copy.notOfficial': 'These are practice copying statistics, not an exam grade.',
  'review.copy.blank':
    'The confirmed text has no words, so there is nothing to compare. If you wrote something, check the recognition.',
  'review.copy.partial':
    'The text is unfinished (about {p} of the reference). The missing ending is counted separately; the rest is graded as is.',
  'review.copy.counts': 'Mistakes by type',
  'review.copy.diffTitle': 'Comparison with the reference',
  'review.copy.diffHint': 'Tap a highlight to see its explanation',
  'review.copy.reference': 'Reference',
  'review.copy.yours': 'Your text (confirmed)',
  'review.copy.notInReference': 'not in reference',
  'review.copy.missing': 'missing',
  'review.copy.writtenAs': 'written as',
  'review.copy.perfect': 'Not a single difference from the reference. Excellent work!',
  'review.copy.recallSection': 'What was not recalled',
  'review.copy.formSection': 'Spelling, tonos and punctuation',
  'review.group.recall': 'Words: omissions and substitutions',
  'review.group.recallMode': 'Omitted and substituted words',
  'review.group.orthography': 'Spelling',
  'review.group.accent': 'Tonos',
  'review.group.punctuation': 'Punctuation',
  'review.group.layout': 'Spacing and paragraphs',
  'review.drill.start': 'Practise',
  'review.drill.title': 'Fragment drill',

  'review.free.score': 'Practice score',
  'review.free.words': 'Words in the text: {n}',
  'review.free.summary': 'Summary',
  'review.free.strengths': 'What went well',
  'review.free.rubric': 'Criteria',
  'review.free.rubricNote': 'practice rubric, not official',
  'review.free.coverage': 'Task coverage',
  'review.free.point': 'Task point',
  'review.free.covered': 'Covered',
  'review.free.evidence': 'Where in the text',
  'review.cov.yes': 'yes',
  'review.cov.partly': 'partly',
  'review.cov.no': 'no',
  'review.free.yourText': 'Your text with notes',
  'review.free.errors': 'Mistakes',
  'review.free.noErrors': 'No clear mistakes found.',
  'review.free.acceptable': 'Acceptable',
  'review.free.optional': 'Could be improved',
  'review.free.unlocated': 'Could not be linked to the text',
  'review.free.unlocatedNote':
    'These notes could not be matched to an exact place in the text, so they are not marked above.',
  'review.free.suggested': 'better',
  'review.free.relocated': 'The position in the text was adjusted automatically.',
  'review.free.corrected': 'Minimal correction',
  'review.free.correctedNote':
    'A corrected A2-level version — kept apart from your original, which never changes.',
  'review.free.limitations': 'Limitations of this evaluation',
  'review.free.noText': 'The confirmed text for this version is unavailable, so notes are not shown.',
  'review.kind.incorrect': 'Mistake',
  'review.kind.acceptable': 'Acceptable',
  'review.kind.optional': 'Could be improved',
  'review.family.accent': 'Tonos',
  'review.family.orthography': 'Spelling',
  'review.family.grammar': 'Grammar',
  'review.family.punctuation': 'Punctuation',
  'review.family.style': 'Vocabulary & style',

  'review.annot.title': 'Notes in the text',
  'review.annot.toggle': 'Notes',
  'review.annot.note': 'Notes refer to the confirmed text, not to positions on the handwriting. Marked: {n}.',

  'review.versions.title': 'Text versions',
  'review.versions.ocr': 'Recognised · v{v}',
  'review.versions.confirmed': 'Confirmed · v{v}',
  'review.versions.rawBadge': 'Original recognition',
  'review.versions.confirmedBadge': 'Confirmed by you',
  'review.versions.graded': 'This version was graded',
  'review.editText': 'Correct the text',
  'review.reEvaluate': 'Evaluate again',
  'review.reEvaluateTitle': 'Evaluate again?',
  'review.reEvaluateText':
    'A new evaluation version will be created. The current one is kept and stays viewable.',
  'review.reEvaluated': 'Comparison recalculated',
  'review.aiOff': 'AI evaluation is currently off',
  'review.again': 'Try again',
  'review.teacherWaiting':
    'The student has not confirmed the recognised text yet. Feedback appears after confirmation.',
  'review.export.pdf': 'Download PDF',
  'review.export.json': 'Download JSON',
  'review.delete': 'Delete attempt',
  'review.deleteTitle': 'Delete this attempt?',
  'review.deleteText': 'The attempt disappears from history and statistics, and teacher access is revoked.',
  'review.deleted': 'Attempt deleted',

  'review.teacher.title': 'Teacher feedback',
  'review.teacher.badge': 'teacher',
  'review.teacher.note': 'Teachers see this attempt read-only: your original and versions never change.',

  'review.share.open': 'Share',
  'review.share.title': 'Share with a teacher',
  'review.share.text': 'The teacher will see the handwriting, confirmed text and feedback — read-only.',
  'review.share.email': 'Teacher email',
  'review.share.allowComments': 'Allow comments and scores',
  'review.share.allowCommentsHint': 'The teacher can leave a review on this attempt',
  'review.share.privacy': 'You can only share with invited teachers. Access can be revoked at any time.',
  'review.share.submit': 'Share',
  'review.share.done': 'Shared with {email}',
  'review.share.panel': 'Teacher access',
  'review.share.none': 'Nobody can see this attempt yet.',
  'review.share.canComment': 'can comment',
  'review.share.viewOnly': 'view only',
  'review.share.revoke': 'Revoke access',
  'review.share.revokeTitle': 'Revoke access?',
  'review.share.revokeText':
    '{email} will immediately lose access to this attempt. Reviews already left stay with you.',
  'review.share.revoked': 'Access revoked',
};

export default { ru, en };
